import React from "react";
import styles from "assets/jss/material-dashboard-pro-react/views/formsStyle.js";
import { Dialog, makeStyles } from "@material-ui/core";
import PropTypes from "prop-types";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import { Assignment } from "@material-ui/icons";
import CardBody from "components/Card/CardBody";
import GridItem from "components/Grid/GridItem";
import CustomInput from "components/CustomInput/CustomInput";
import ReactTable from "react-table";
import CardFooter from "components/Card/CardFooter";
import Button from "components/CustomButtons/Button.js";

const useStyles = makeStyles(styles);

export default function SindoDialog(props) {
  const {
    setOpenModal,
    openModal,
    title,
    pages,
    pagination,
    loading,
    data,
    columns,
    handleSearchStringChanged,
    searchString,
    setPagination
  } = props;

  const classes = useStyles();
  return (
    <Dialog
      open={openModal}
      onClose={(event, reason) => {
        if (reason === "backdropClick") {
          setOpenModal(false);
        }
      }}
    >
      <Card>
        <CardHeader icon>
          <CardIcon color="primary">
            <Assignment />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>{title}</h4>
        </CardHeader>
        <CardBody>
          <GridItem xs={12} md={3}>
            <CustomInput
              labelText="Search"
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                onChange: handleSearchStringChanged,
                value: searchString ?? ""
              }}
            />
          </GridItem>
          <ReactTable
            manual
            pages={pages}
            page={pagination.pageIndex - 1}
            pageSize={pagination.pageSize}
            onPageChange={page =>
              setPagination({
                pageIndex: page + 1,
                pageSize: pagination.pageSize
              })
            }
            onPageSizeChange={(pageSize, page) => {
              setPagination({ pageSize: pageSize, pageIndex: page + 1 });
            }}
            loading={loading}
            data={data}
            filterable={false}
            columns={columns}
            defaultPageSize={10}
            showPaginationTop
            showPaginationBottom={false}
            className="-striped -highlight"
          />
        </CardBody>
      </Card>
      <CardFooter>
        <Button
          onClick={() => {
            setOpenModal(false);
          }}
          type="submit"
          color="danger"
          size="sm"
          block
        >
          Close
        </Button>
      </CardFooter>
    </Dialog>
  );
}

SindoDialog.propTypes = {
  openModal: PropTypes.bool,
  setOpenModal: PropTypes.func,
  title: PropTypes.string,
  pages: PropTypes.number,
  pagination: PropTypes.object,
  loading: PropTypes.bool,
  data: PropTypes.object,
  columns: PropTypes.array,
  handleSearchStringChanged: PropTypes.func,
  searchString: PropTypes.string,
  setPagination: PropTypes.func
};
